import React from "react";
import { connect } from "react-redux";
import { Menu, Dropdown, Tooltip } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { setSelectedUserRole } from "../../apis/login/auth";
import { compactRoleKey } from "../../utils/roleUtils";

const formatRoleLabel = (role) => {
  if (!role) return "";
  return String(role)
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

export const NavRoleSelector = ({
  userRoles,
  selectedUserRole,
  isAuthenticated,
  setSelectedUserRole,
}) => {
  if (!isAuthenticated) return null;
  // Never offer the plain "USER" role in the picker — it is not a selectable hat here.
  const visibleRoles = (Array.isArray(userRoles) ? userRoles : []).filter(
    (r) => compactRoleKey(r) !== "USER"
  );
  if (visibleRoles.length === 0) return null;

  const onSelect = ({ key }) => {
    if (key === selectedUserRole) return;
    setSelectedUserRole(key);
    // Refresh so role-scoped data/tabs everywhere honor the new selection.
    window.location.reload();
  };

  const activeRole =
    selectedUserRole && compactRoleKey(selectedUserRole) !== "USER"
      ? selectedUserRole
      : visibleRoles[0];

  if (visibleRoles.length === 1) {
    return (
      <Tooltip title="Your Role" placement="bottom">
        <span
          className="text-white mr-3"
          style={{ fontSize: "13px", fontWeight: 500 }}
        >
          {formatRoleLabel(activeRole)}
        </span>
      </Tooltip>
    );
  }

  const overlay = (
    <Menu
      selectable
      selectedKeys={[activeRole]}
      onClick={onSelect}
      style={{ minWidth: 220 }}
    >
      <Menu.ItemGroup title="Select Role">
        {visibleRoles.map((r) => (
          <Menu.Item key={r}>{formatRoleLabel(r)}</Menu.Item>
        ))}
      </Menu.ItemGroup>
    </Menu>
  );

  return (
    <Dropdown overlay={overlay} placement="bottomRight" trigger={["click"]}>
      <span
        className="text-white mr-3"
        style={{ fontSize: "13px", cursor: "pointer", fontWeight: 500 }}
      >
        {formatRoleLabel(activeRole)}
        <CaretDownOutlined style={{ fontSize: "13px", marginLeft: 4 }} />
      </span>
    </Dropdown>
  );
};

const mapStateToProps = ({ auth }) => ({
  userRoles: auth.userRoles ?? [],
  selectedUserRole: auth.selectedUserRole,
  isAuthenticated: auth.isAuthenticated,
});

export default connect(mapStateToProps, { setSelectedUserRole })(
  NavRoleSelector
);
